import adminRequest from 'utils/adminRequest'

/** Slots of one assessment map; `interview.onCall` is false for anything that is not an on-call AI Interview. */
export const fetchCallSlots = async (mapId, page = 1) => {
  const res = await adminRequest.get(`/ai-interview/call-interviews/${mapId}/slots`, { params: { page, pageSize: 50 } })
  return res.data?.data
}

/** Reschedule ({ scheduledAtIst }), change number ({ phone }), cancel ({ action: 'cancel' }) or re-queue ({}). */
export const updateCallSlot = async (slotId, update) => {
  try {
    await adminRequest.patch(`/ai-interview/call-slots/${slotId}`, update)
    return null
  } catch (error) {
    return error?.response?.data?.message || 'Could not update the call. Try again.'
  }
}
